import React from "react"
import {Typography, Container, Divider} from "@mui/material"
import {makeStyles} from "@mui/styles"
import {createTheme} from '@mui/material/styles'


const theme = createTheme()

const useStyles = makeStyles({
    skills:{
        display:"flex",
        justifyContent:"space-evenly",
        
    },

    mySkill:{
        height:"auto",
        marginBottom:"4rem",
        marginTop:"2rem"
    }
})


const Skill = () =>{
    const classes = useStyles()

    return(
        <div className={classes.mySkill} id="skills">
        <Container maxWidth="lg">
            <Typography variant="h4" style={{marginTop:'3rem'}} data-aos="zoom-in-down">My Skills</Typography>
            <Divider />

<Typography variant="h6" style={{paddingTop:"1rem", marginTop:"1rem"}} data-aos="fade-right"> HTML/CSS & JavaScript</Typography>
<Divider style={{backgroundColor:"#98AD06"}} />
<Typography variant="h6" style={{paddingTop:"1rem"}} data-aos="fade-right"> TypeScript</Typography>
<Divider style={{backgroundColor:"red"}} />
<Typography variant="h6" style={{paddingTop:"1rem"}} data-aos="fade-right"> MERN (MongoDB, Express, React, Nodes)</Typography>
<Divider style={{backgroundColor:"#A75600"}} />
<Typography variant="h6" style={{paddingTop:"1rem"}} data-aos="fade-right"> Redux, Context API</Typography>
<Divider style={{backgroundColor:"#572D1B"}} />
<Typography variant="h6" style={{paddingTop:"1rem"}} data-aos="fade-right"> Material UI/ Styled Components</Typography>
<Divider style={{backgroundColor:"#1A2DF1"}} />
<Typography variant="h6" style={{paddingTop:"1rem"}} data-aos="fade-right"> WordPress/Sanity Studio</Typography>
<Divider style={{backgroundColor:"violet"}}  />

        </Container>
</div>
    )
}

export default Skill
